import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { customersData } from "../../store/reducer/customersSlice";
import { useAppSelector } from "../../utils/hooks";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Stack } from "@mui/system";
import i18n from "../../i18n/config";
import { useTranslation } from "react-i18next";
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function CustomerAccordion({ orderByCustomer }) {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(false);
  const { customers } = useAppSelector(customersData);
  console.log(orderByCustomer);
  const findProductName = (id) => {
    console.log(id);
    let customer = customers.find((el) => el.id.toString() === id.toString());
    return customer.name_english + "     " + customer.name_urdu;
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Stack
        marginTop={8}
        backgroundColor="lightGray"
        borderTop={2}
        marginY={5}
        marginX={isMediumScreen ? 5 :0}
        spacing={1}
      >
        <Typography
          fontSize={"18px"}
          fontWeight="bold"
          color="green"
          style={{ textAlign: "center",minWidth:300 }
        }
        >
          {t("Order by customers")}{" ( "}
          {orderByCustomer.length} {" )"}
        </Typography>
        {orderByCustomer.map((customer) => {
          return (
            <Accordion
              expanded={expanded === customer.customerId.toString()}
              onChange={handleChange(customer.customerId.toString())}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography sx={{ width: "100%", textAlign:'justify' }} color={"green"}>
                  {findProductName(customer.customerId)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Table
                  sx={{ minWidth: isMediumScreen ? '680px' : '250px', marginTop: "2rem" }}
                  aria-label="simple table"
                  align="center"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell width={"50%"}>
                        <Typography fontSize={"18px"} fontWeight="bold"  textAlign="center">
                        {t("Quantity")}{/* شمار */}
                        </Typography>
                      </TableCell>
                      <TableCell width={"50%"} >
                        <Typography
                          fontSize={"18px"}
                          fontWeight="bold"
                          marginLeft="5rem"
                          textAlign="center"
                        >
                         {t("Product")} {/* پروڈکٹ کا نام */}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customer.order.map((row) => {
                      return (
                        <TableRow key={row.id}>
                          <TableCell align="center" style={{ fontSize: 15,width:'50%' }}>
                            {row.quantity}{" "}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 18, paddingLeft: "5rem",width:'50%' }}
                          >
                            {i18n.language === "ur" ? row.name_urdu : row.name_english}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Stack>
    </div>
  );
}
